import script from "./VueSkipToList.vue?vue&type=script&lang=ts&setup=true"
export * from "./VueSkipToList.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__